import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialSize from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { PDFHeader } from "../../../../../global/globalFunctions";


const ViewLevelTwo = (props) => {
    useEffect(() => {
        props.setHeading("View Level Two");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialSize
                    title="View Level Two"
                    columns={[
                        {
                            title: 'Level 1 Name', field: 'levelOneId.name', editable: 'never',
                            render: rowData => `${rowData.levelOneId.key} - ${rowData.levelOneId.name}`
                        },
                        { title: 'Level 2 Code', field: 'allKey' },
                        { title: 'Level 2 Name', field: 'levelTwoName' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/levelTwo/?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data.sort((a, b) => a.levelOneId.key - b.levelOneId.key),
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "potrait";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Level Two Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.levelOneId.name,
                                elt.allKey,
                                elt.levelTwoName,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Level Two Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingLevelTwo: state.LevelTwoReducer.isFetchingLevelTwo,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewLevelTwo);